<template>
  <section class="section-box-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="logo-footer">
            <a href="http://artweb.ua/ru">
              Designed by Artweb
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    performLogout () {
      this.$store.dispatch('security/logout')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
